import Select from "react-select";
import {
  Board,
  BoardHeader,
  BoardSearchDetail,
  BoardTableContainer,
  CalendarBox,
  CalendarIcon,
  ColSpan1,
  ColSpan2,
  CustomDatePicker,
  DateContainer,
  inputStyle,
  RangePicker,
  RowSpan,
  SearchButton,
  SearchInput
} from "../../assets/GlobalStyles";
import {HorizontalRule} from "../../components/common/Common";
import ko from "date-fns/locale/ko";
import React, {useCallback, useState} from "react";
import Table from "../../components/table";
import {columnHistoryData, mediaSearchTypeByHistory, searchHistoryParams} from "./entity/common";
import {
  getLastDay,
  getLastMonth,
  getLastNinetyDay,
  getLastThirtyDay,
  getLastWeekDay,
  getThisMonth,
  getToDay
} from "../../common/DateUtils";
import {selHistoryList} from "../../services/platform/HistoryAxios";

const mainColor = 'var(--theme-main)';
export const dataTotalInfo = {
  totalCount:1,
  currentCount:1,
  totalPages:1,
  currentPage:1
}

function PlatformHistory() {
  const [dateRange, setDateRange] = useState([new Date(getThisMonth().startDay), new Date(getToDay())]);
  const [startDate, endDate] = dateRange
  const [searchHistoryParamsState, setSearchHistoryParamsState] = useState(searchHistoryParams)
  const [mediaSearchTypeByHistoryState] = useState(mediaSearchTypeByHistory)
  const [pickedDate, setPickedDate] = useState('')
  const [totalInfo, setTotalInfo] = useState(dataTotalInfo);
  const [, setIsSearch] = useState(false);

  const handleMediaSearchTypeByHistory = (selectSearchType) => {
    setSearchHistoryParamsState({
      ...searchHistoryParamsState,
      searchKeywordType: selectSearchType,
      searchKeyword: selectSearchType.value !== null ? searchHistoryParamsState.searchKeyword: ''
    })
  }

  const handleMediaSearchValueByHistory = (event) => {
    setSearchHistoryParamsState({
      ...searchHistoryParamsState,
      searchKeyword: event.target.value
    })
  }

  /**
   * 기간변 버튼 이벤트
   * @param rangeType
   */
  const handleRangeDate = (rangeType) => {
    setPickedDate(rangeType)
    if (rangeType === 'thisMonth') {
      setSearchHistoryParamsState({
        ...searchHistoryParamsState,
        searchStartDate: getThisMonth().startDay,
        searchEndDate: getThisMonth().endDay
      })
      setDateRange([new Date(getThisMonth().startDay), new Date(getThisMonth().endDay)])
    } else if (rangeType === 'lastMonth') {
      setSearchHistoryParamsState({
        ...searchHistoryParamsState,
        searchStartDate: getLastMonth().startDay,
        searchEndDate: getLastMonth().endDay
      })
      setDateRange([new Date(getLastMonth().startDay), new Date(getLastMonth().endDay)])
    } else if (rangeType === 'today') {
      setSearchHistoryParamsState({
        ...searchHistoryParamsState,
        searchStartDate: getToDay(),
        searchEndDate: getToDay()
      })
      setDateRange([new Date(), new Date()])
    } else if (rangeType === 'lastDay') {
      setSearchHistoryParamsState({
        ...searchHistoryParamsState,
        searchStartDate: getLastDay(),
        searchEndDate: getLastDay()
      })
      setDateRange([new Date(getLastDay()), new Date(getLastDay())])
    } else if (rangeType === 'lastWeekDay') {
      setSearchHistoryParamsState({
        ...searchHistoryParamsState,
        searchStartDate: getLastWeekDay().startDay,
        searchEndDate: getLastWeekDay().endDay
      })
      setDateRange([new Date(getLastWeekDay().startDay), new Date(getLastWeekDay().endDay)])
    } else if (rangeType === 'lastThirtyDay') {
      setSearchHistoryParamsState({
        ...searchHistoryParamsState,
        searchStartDate: getLastThirtyDay().startDay,
        searchEndDate: getLastThirtyDay().endDay
      })
      setDateRange([new Date(getLastThirtyDay().startDay), new Date(getLastThirtyDay().endDay)])
    } else if (rangeType === 'lastNinetyDay') {
      setSearchHistoryParamsState({
        ...searchHistoryParamsState,
        searchStartDate: getLastNinetyDay().startDay,
        searchEndDate: getLastNinetyDay().endDay
      })
      setDateRange([new Date(getLastNinetyDay().startDay), new Date(getLastNinetyDay().endDay)])
    }
  }

  const searchHistoryInfo =()=>{
    setIsSearch(true);
  }

  const dataSource = useCallback(({skip, limit}) => {
    const params = {
      ...searchHistoryParamsState,
      currentPage: skip / limit === 0 ? 1 : skip / limit + 1,
      pageSize: limit,
    };

    return selHistoryList(params).then(response => {
      if (response !== null) {
        setIsSearch(false);
        setTotalInfo({
          totalCount: response.totalCount,
          currentCount: response?.content.length,
          currentPage: response.currentPage,
          totalPages: response.totalPages,
        });

        return {
          data: response.content,
          count: parseInt(response.totalCount),
        };
      }

      return {
        data: [],
        count: 0,
      };
    });
  }, [searchHistoryParamsState]);

  return (
    <Board>
      <BoardHeader>광고 이력 관리</BoardHeader>
      <BoardSearchDetail>
        {/*line1*/}
        <RowSpan>
          <ColSpan1>
            <div>
              <DateContainer>
                <CalendarBox>
                  <CalendarIcon/>
                </CalendarBox>
                <CustomDatePicker
                  selectsRange={true}
                  startDate={startDate}
                  endDate={endDate}
                  maxDate={new Date()}
                  locale={ko}
                  onChange={(date) => {
                    setDateRange(date);

                    if (date[0] && date[1]) {
                      setSearchHistoryParamsState({
                        ...searchHistoryParamsState,
                        searchStartDate: date[0],
                        searchEndDate: date[1],
                      });
                    }
                  }}
                  dateFormat="yyyy-MM-dd"
                  isClearable={false}
                />
              </DateContainer>
            </div>
          </ColSpan1>
          <ColSpan2>
            <RangePicker>
              <div onClick={() => handleRangeDate('thisMonth')} style={pickedDate === 'thisMonth' ? {color: `${mainColor}`, fontWeight: "bold"}:null}>이번달</div>
              <HorizontalRule style={{margin: "0 10px"}}/>
              <div onClick={() => handleRangeDate('lastMonth')} style={pickedDate === 'lastMonth' ? {color:`${mainColor}`, fontWeight: "bold"}:null}>지난달</div>
              <HorizontalRule style={{margin: "0 10px"}}/>
              <div onClick={() => handleRangeDate('today')} style={pickedDate === 'today' ? {color:`${mainColor}`, fontWeight: "bold"}:null}>오늘</div>
              <HorizontalRule style={{margin: "0 10px"}}/>
              <div onClick={() => handleRangeDate('lastDay')} style={pickedDate === 'lastDay' ? {color:`${mainColor}`, fontWeight: "bold"}:null}>어제</div>
              <HorizontalRule style={{margin: "0 10px"}}/>
              <div onClick={() => handleRangeDate('lastWeekDay')} style={pickedDate === 'lastWeekDay' ? {color:`${mainColor}`, fontWeight: "bold"}:null}>지난7일</div>
              <HorizontalRule style={{margin: "0 10px"}}/>
              <div onClick={() => handleRangeDate('lastThirtyDay')} style={pickedDate === 'lastThirtyDay' ? {color:`${mainColor}`, fontWeight: "bold"}:null}>지난30일</div>
              <HorizontalRule style={{margin: "0 10px"}}/>
              <div onClick={() => handleRangeDate('lastNinetyDay')} style={pickedDate === 'lastNinetyDay' ? {color:`${mainColor}`, fontWeight: "bold"}:null}>지난90일</div>
            </RangePicker>
          </ColSpan2>
          <ColSpan1>
            <Select styles={inputStyle}
                    options={mediaSearchTypeByHistoryState}
                    value={searchHistoryParamsState.searchKeywordType.value != null ? mediaSearchTypeByHistoryState.find(option => option.value === searchHistoryParamsState.searchKeywordType) : mediaSearchTypeByHistoryState[0]}
                    onChange={handleMediaSearchTypeByHistory}
            />
          </ColSpan1>
          <ColSpan2>
            <SearchInput>
              <input type={'text'}
                     placeholder={searchHistoryParamsState.searchKeywordType.value != null ?'검색어를 입력해 주세요.' : '검색 항목을 선택해 주세요.'}
                     value={searchHistoryParamsState.searchKeyword || ""}
                     onChange={handleMediaSearchValueByHistory}
                     onKeyDown={e => (e.key === 'Enter') && searchHistoryInfo()}
                     readOnly={(searchHistoryParamsState.searchKeywordType === '' || searchHistoryParamsState.searchKeywordType.value === null) ? true:false}
              />
            </SearchInput>
            <SearchButton onClick={searchHistoryInfo}>적용</SearchButton>
          </ColSpan2>
        </RowSpan>
      </BoardSearchDetail>
      <BoardTableContainer>
        <Table columns={columnHistoryData}
               rowHeight={100}
               totalCount={[totalInfo.currentCount, '광고 이력']}
               defaultLimit={searchHistoryParamsState.pageSize}
               data={dataSource}
               idProperty={'id'}
               pagination={true}
        />
      </BoardTableContainer>
    </Board>
  )
}

export default PlatformHistory
